
export class MonthlyCostData
{
    public workingStatus: string
    public trainPassStatus: string
    public empCd: string
    public empNm: string
    public divisionNm: string
    public divisionSnm: string
    public ym: string
    public monthlyStatus: string
    public trainPassInfo: string
    public dailyAllowanceAmount: number
    public trainPassPurchaseInfo: string
    public decisionRemarks: string
    public approvalDate1st: string
    public approvalEmpCd1st: string
    public approvalEmpNm1st: string
    public approvalDate2nd: string
    public approvalEmpCd2nd: string
    public approvalEmpNm2nd: string
    public approvalDate3rd: string
    public approvalEmpCd3rd: string
    public approvalEmpNm3rd: string
    public confirmDate1st: string
    public confirmEmpCd1st: string
    public confirmEmpNm1st: string
    public confirmDate2nd: string
    public confirmEmpCd2nd: string
    public confirmEmpNm2nd: string
    public confirmDate3rd: string
    public confirmEmpCd3rd: string
    public confirmEmpNm3rd: string
    public renewDate: string
}